import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    [breakpoints.up('lg')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    [breakpoints.up('lg')]: {
      flexWrap: 'wrap',
    },
  },
  full: {
    '&&': {
      [breakpoints.up('lg')]: {
        width: '100%',
      },
    },
  },
  row: {
    '&&': {
      [breakpoints.up('lg')]: {
        flexDirection: 'row',
        width: '100%',
      },
    },
  },
  wide: {
    [breakpoints.up('lg')]: {
      width: 'calc(58.7% - 0.375rem)',
    },
  },
  narrow: {
    [breakpoints.up('lg')]: {
      width: 'calc(41.3% - 0.375rem)',
    },
    '& > div:last-of-type': {
      [breakpoints.up('lg')]: {
        flexGrow: 1,
      },
    },
  },
}));
